// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_Promise = require("@rescript/runtime/lib/js/Stdlib_Promise.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let StripeJs = require("@stripe/stripe-js");
let ReactStripeJs = require("@stripe/react-stripe-js");

function fromJs(obj) {
  let match = obj.brand;
  let tmp;
  switch (match) {
    case "American Express" :
      tmp = "AmericanExpress";
      break;
    case "Discover" :
      tmp = "Discover";
      break;
    case "MasterCard" :
      tmp = "MasterCard";
      break;
    case "Visa" :
      tmp = "Visa";
      break;
    default:
      tmp = "Unknown";
  }
  return {
    expMonth: obj.exp_month,
    expYear: obj.exp_year,
    brand: tmp,
    last4: obj.last4,
    name: obj.name
  };
}

function fromJs$1(obj) {
  return {
    id: obj.id,
    card: fromJs(obj.card)
  };
}

function getCardElement(t, elementType) {
  return t.getElement(elementType);
}

function useElements() {
  return Primitive_option.fromNullable(ReactStripeJs.useElements());
}

function useStripe() {
  return Primitive_option.fromNullable(ReactStripeJs.useStripe());
}

function createToken(apiInstance, cardElement, data) {
  return Stdlib_Promise.$$catch(apiInstance.createToken(cardElement, data).then(response => {
    let match = response.token;
    let match$1 = response.error;
    if (match == null) {
      if (match$1 == null) {
        return {
          TAG: "Error",
          _0: {
            code: "no code",
            message: "no message",
            type: "no type"
          }
        };
      } else {
        return {
          TAG: "Error",
          _0: match$1
        };
      }
    } else {
      return {
        TAG: "Ok",
        _0: fromJs$1(match)
      };
    }
  }), param => Promise.resolve({
    TAG: "Error",
    _0: {
      code: "no code",
      message: "no message",
      type: "no type"
    }
  }));
}

let API = {
  createToken: createToken
};

function loadStripe(prim) {
  return StripeJs.loadStripe(prim);
}

let Card = {};

let Token = {};

let React_Elements = {
  getCardElement: getCardElement,
  make: ReactStripeJs.Elements
};

let React = {
  Elements: React_Elements,
  useElements: useElements,
  useStripe: useStripe
};

exports.loadStripe = loadStripe;
exports.Card = Card;
exports.Token = Token;
exports.React = React;
exports.API = API;
/* React Not a pure module */
